var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title: "Anular Expediente " + _vm.canceledFile.numero,
        "hide-footer": "",
        centered: ""
      },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c("div", {}, [
        _vm._v(
          " Para anular el expediente debes realizarlo bajo la seguridad del 2FA o Cód. de verificación "
        )
      ]),
      _c(
        "div",
        { staticClass: "wrap-option" },
        [
          _c(
            "vs-radio",
            {
              attrs: { "vs-value": "twoFa" },
              model: {
                value: _vm.cancel.typeCancel,
                callback: function($$v) {
                  _vm.$set(_vm.cancel, "typeCancel", $$v)
                },
                expression: "cancel.typeCancel"
              }
            },
            [_vm._v("2FA (OTP)")]
          ),
          _c(
            "vs-radio",
            {
              attrs: {
                "data-cy": "Verification-code",
                "vs-value": "internCode"
              },
              model: {
                value: _vm.cancel.typeCancel,
                callback: function($$v) {
                  _vm.$set(_vm.cancel, "typeCancel", $$v)
                },
                expression: "cancel.typeCancel"
              }
            },
            [_vm._v(" Código de Verificación ")]
          )
        ],
        1
      ),
      _vm.cancel.typeCancel === "internCode"
        ? _c(
            "div",
            { staticClass: "wrap-form" },
            [
              _c(
                "vs-row",
                [
                  _c(
                    "vs-col",
                    {
                      attrs: {
                        "vs-type": "flex",
                        "vs-justify": "center",
                        "vs-align": "center",
                        "vs-w": "6"
                      }
                    },
                    [
                      _c(
                        "vs-button",
                        {
                          attrs: {
                            "data-cy": "request-code",
                            size: "small",
                            disabled: _vm.gettingCode,
                            color: "primary"
                          },
                          on: {
                            click: function($event) {
                              return _vm.getCode()
                            }
                          }
                        },
                        [_vm._v(" Solicitar código ")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "vs-col",
                    {
                      attrs: {
                        "vs-type": "flex",
                        "vs-justify": "center",
                        "vs-align": "center",
                        "vs-w": "6"
                      }
                    },
                    [
                      _c("vs-input", {
                        attrs: {
                          "data-cy": "write-verification-code",
                          oninput:
                            "javascript: if (this.value.length > this.maxLength)\n            this.value = this.value.slice(0, this.maxLength);",
                          maxlength: "8",
                          label: "Código de Verificación"
                        },
                        model: {
                          value: _vm.cancel.code,
                          callback: function($$v) {
                            _vm.$set(_vm.cancel, "code", $$v)
                          },
                          expression: "cancel.code"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.cancel.typeCancel === "twoFa"
        ? _c(
            "div",
            { staticClass: "wrap-form" },
            [
              _c("vs-input", {
                attrs: {
                  oninput:
                    "javascript: if (this.value.length > this.maxLength)\n        this.value = this.value.slice(0, this.maxLength);",
                  maxlength: "8",
                  label: "Código de Verificación"
                },
                model: {
                  value: _vm.cancel.code,
                  callback: function($$v) {
                    _vm.$set(_vm.cancel, "code", $$v)
                  },
                  expression: "cancel.code"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "wrap-commentary" },
        [
          _c("p", { staticClass: "comment-text" }, [
            _vm._v("*Los saltos de línea serán removidos")
          ]),
          _c("vs-textarea", {
            attrs: {
              "data-cy": "write-comment",
              maxlength: "255",
              label: "Comentario"
            },
            model: {
              value: _vm.comment,
              callback: function($$v) {
                _vm.comment = $$v
              },
              expression: "comment"
            }
          }),
          _vm.notValid
            ? _c("div", [
                _c("small", { staticStyle: { color: "red" } }, [
                  _vm._v(
                    " No has ingresado un comentario para validar esta acción "
                  )
                ])
              ])
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { "margin-top": "20px", "text-align": "center" } },
        [
          _c(
            "vs-button",
            {
              attrs: {
                "data-cy": "cancel-file",
                color: "primary",
                type: "border"
              },
              on: {
                click: function($event) {
                  return _vm.cancelFile()
                }
              }
            },
            [_vm._v(" Anular Expediente ")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }